import * as React from 'react';

import {getChannelIconFromInt} from '../../../channels/helpers';

import {ItemWithIcon} from './item-with-icon';
import {TruncatedItems} from './truncated-items';

export type SourceType = {
    id: string;
    name: string;
    channel:
        | {
              value: number;
              display: string;
          }
        | null
        | undefined;
};

type Props = {
    value: SourceType[];
};

export function Source(props: Props) {
    return (
        // @ts-expect-error
        <TruncatedItems
            value={props.value}
            isTokenized={true}
            renderRow={(source: SourceType) => {
                return (
                    <ItemWithIcon
                        key={source.id}
                        tooltipText={
                            source.channel
                                ? `${source.name} • ${source.channel.display}`
                                : undefined
                        }
                        icon={
                            source.channel ? getChannelIconFromInt(source.channel.value) : undefined
                        }
                        text={source.name}
                    />
                );
            }}
        />
    );
}
